import { css, Global } from "@emotion/react";
import "normalize.css";
import React from "react";
import { cssVars } from "./themes/themes";

export const Globals = () => {
  return (
    <Global
      styles={css`
        @font-face {
          font-family: "TTNorms";
          src: local("TTNorms"),
            url("/fonts/TTNorms-Regular.otf") format("opentype");
        }

        @font-face {
          font-family: "TTNorms";
          font-weight: 500;
          src: local("TTNorms"),
            url("/fonts/TTNorms-Medium.otf") format("opentype");
        }

        @font-face {
          font-family: "TTNorms";
          font-weight: 600;
          src: local("TTNorms"),
            url("/fonts/TTNorms-DemiBold.ttf") format("truetype");
        }

        @font-face {
          font-family: "TTNorms";
          font-weight: 700;
          src: local("TTNorms"),
            url("/fonts/TTNorms-Bold.otf") format("opentype");
        }

        :root {
          ${cssVars}
        }

        body {
          color: var(--colors-text);
          background: var(--colors-neutral-5);
          font-weight: var(--fontWeights-0);
        }

        b {
          font-weight: var(--fontWeights-1);
        }
      `}
    />
  );
};
